import { RulebookPage } from "@/components/RulebookPage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { currentRules } from "@/data/rules";
import { DescriptionBlocks } from "./DescriptionBlocks";

export function CoreSkills() {
  const skills = currentRules.coreSkills;

  return (
    <RulebookPage title="Core Skills">
      <p className="text-sm text-muted-foreground mb-3">
        You have 3 skill points to spend at the start of the game to represent
        your life experience. Each core skill costs 1 point. Every character
        begins the game with 3 HP, 1 MP, 1 WL, and the ability to use Small
        Weapons.
      </p>

      <div className="grid gap-3">
        {skills.map((skill) => (
          <Card key={skill.id}>
            <CardHeader className="pb-2">
              <div className="flex items-center gap-2">
                <CardTitle className="text-base">{skill.name}</CardTitle>
                {skill.repeatable && (
                  <Badge variant="secondary" className="text-xs">
                    Repeatable
                    {skill.maxTimes ? ` (max ${skill.maxTimes}×)` : ""}
                  </Badge>
                )}
              </div>
            </CardHeader>
            <CardContent>
              {skill.full_description ? (
                <DescriptionBlocks blocks={skill.full_description} />
              ) : (
                <p className="text-sm text-muted-foreground">
                  {skill.description}
                </p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </RulebookPage>
  );
}
